<script lang="ts">
  import Label from '$src/js/modules/ui/components/form/Label.svelte';
  import Input from '$src/js/modules/ui/components/form/Input.svelte';
  import Select from '$src/js/modules/ui/components/form/Select.svelte';
  import Datepicker from '$src/js/modules/ui/components/form/Datepicker.svelte';
  import type { FormField } from '$src/types/forms';
  import DateOfBirth from '$src/js/modules/ui/components/form/DateOfBirth.svelte';
  import Textarea from '$src/js/modules/ui/components/form/Textarea.svelte';
  import DatePickerSingle from '$src/js/modules/ui/components/form/DatePickerSingle.svelte';

  let {
    id,
    label,
    hideLabel,
    required,
    background,
    value = $bindable(''),
    type,
    name,
    customValidation,
    attributes,
    options,
    placeholder,
    min,
    onBlur,
    onChange,
    showFirstEmptyValue = true,
    footnote,
  }: FormField = $props();

  // Black is the default here
  const style = {
    backgroundColor: 'var(--color-black-1000)',
    textColor: 'var(--color-white-1000)',
    borderColor: 'var(--color-white-1000)',
  };

  if (background === 'yellow') {
    style.backgroundColor = 'var(--color-primary)';
    style.textColor = 'var(--color-black-1000)';
    style.borderColor = 'var(--color-black-1000)';
  }
</script>

<div
  class="flex w-full flex-col gap-2"
  style={`--border-color: ${style.borderColor}; --text-color: ${style.textColor}; --background-color: ${style.backgroundColor};`}
>
  {#if !hideLabel}
    <Label {id} {label} {hideLabel} {required} />
  {/if}

  {#if type === 'select'}
    <Select
      {id}
      {name}
      {required}
      {attributes}
      {options}
      {showFirstEmptyValue}
      bind:value
      {onBlur}
      {background}
      {onChange}
    />
  {:else if type === 'date'}
    <Datepicker
      {id}
      {name}
      {required}
      {attributes}
      {placeholder}
      bind:value
      {onBlur}
      {onChange}
    />
  {:else if type === 'singleDate'}
    <DatePickerSingle
      {id}
      {name}
      {required}
      {attributes}
      {placeholder}
      bind:value
      {onBlur}
      {onChange}
    />
  {:else if type === 'dateOfBirth'}
    <DateOfBirth
      {id}
      {name}
      {required}
      {attributes}
      {placeholder}
      bind:value
      {onBlur}
      {onChange}
    />
  {:else if type === 'textarea'}
    <Textarea
      {id}
      {name}
      {required}
      {attributes}
      {placeholder}
      bind:value
      {onBlur}
      {onChange}
    />
  {:else}
    <Input
      {id}
      {name}
      {required}
      {attributes}
      {placeholder}
      {customValidation}
      {type}
      {min}
      bind:value
      {onBlur}
      {onChange}
    />
  {/if}

  {#if footnote}
    <span class="text-12px text-white-600 2xl:fluit-mt-[8] mt-2"
      >{footnote}</span
    >
  {/if}
</div>
